import React from 'react';
import { useFormContext } from 'react-hook-form';

import * as styled from './styles';

type Props = {
  name: string;
  label?: string;
  type?:
    | 'text'
    | 'email'
    | 'tel'
    | 'password'
    | 'number'
    | 'url'
    | 'date'
    | 'datetime-local'
    | 'time';
  placeholder?: string;
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  maxLength?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
};

const NAME_AUTOCOMPLETES = new Set([
  'name',
  'given-name',
  'additional-name',
  'family-name',
  'nickname',
  'username',
]);

export const FormField = ({
  name,
  label,
  type = 'text',
  autoComplete,
  style,
  ...rest
}: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message as string | undefined;

  const isEmail = type === 'email';
  const isName = !!autoComplete && NAME_AUTOCOMPLETES.has(autoComplete);

  const autoCapitalize = isEmail ? 'none' : isName ? 'words' : undefined;
  const autoCorrect = isEmail || isName ? 'off' : undefined;
  const spellCheck = isEmail || isName ? false : undefined;

  return (
    <styled.Field>
      {label && <styled.Label>{label}</styled.Label>}
      <styled.Input
        {...register(name)}
        type={type}
        $hasError={!!error}
        aria-invalid={!!error}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        spellCheck={spellCheck}
        style={style}
        {...rest}
      />
      {error && <styled.ErrorText>{error}</styled.ErrorText>}
    </styled.Field>
  );
};
